import { EventEmitter, Injectable } from '@angular/core';
import { Annonceur } from '../models/annonceur.model';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import {
  DialogMessageComponent,
  DialogAnnulationCampagneComponent,
} from 'app/campagne/components';
import { Campagne } from '@core/models/campagne.model';
import { SafeUrl } from '@angular/platform-browser';
import { MatStepper } from '@angular/material/stepper';
import { FormGroup } from '@angular/forms';
import { AdresseRetour } from '@core/models/adresseRetour.model';
import { CampagneExt } from '@core/models/campagne-ext.model';
import {
  Criteria,
  EstimationRequest,
} from '@core/models/estimationRequest.model';
import { Produit } from '@core/models/produit.model';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { Observable, of, switchMap, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class GlobalDataService {
  private readonly jwtStorageKeyByContext: Record<string, string> = {
    ADMIN: 'ADMIN_APP_JWT',
    ELOQUA: 'ELOQUA_APP_JWT',
    STANDALONE: 'STANDALONE_APP_JWT',
    SALESFORCE: 'SALESFORCE_APP_JWT',
  };
  private readonly campaignStepStoragePrefix = 'CMP_CAMPAIGN_STEP';
  private readonly campaignDraftStoragePrefix = 'CMP_CAMPAIGN_DRAFT';
  private readonly navViewStateStoragePrefix = 'CMP_NAVVIEW_STATE';
  private readonly currentCampaignNavigationStoragePrefix = 'CMP_CURRENT_CAMPAIGN_NAVIGATION';
  private readonly campaignNavigationViews = new Set([
    'campagne-details',
    'suivi-campagne-recurrente',
    'suivi-campagne-une-seule-fois',
  ]);
  Annonceur: Annonceur = new Annonceur();
  version: string = environment.version;

  public localAnnonceur: Annonceur = new Annonceur();
  public objectParams: any;
  public produits = new Array<Produit>();
  listEnveloppeProduits$ = new BehaviorSubject([]);
  public listChampsFusionDisponible = [];
  public availableChampsFusion = [];
  public availableEloquaChampsFusion = [];
  public availableAdresses = [];
  public sharedListEloqua = [];
  public sharedListNames = [];
  public mappingStatut: { [key: string]: string } = {};
  public mappingPercentage: { [key: string]: string } = {};

  public showStepEnveloppeNC = true; //afficher ou non l'étape Enveloppe de la création de la campagne

  public stepCompleted_IdentifCamp = false;
  public stepCompleted_Support = false;
  public stepCompleted_Enveloppe = false;
  public stepCompleted_AdresseR = false;
  public stepCompleted_FichieCrea = false;
  public stepCompleted_Freq = false;
  public stepCompleted_ServiceAdd = false;
  public stepCompleted_Confirmation = false;

  public stepIndex: number;

  public referenceDocHelp = ''; // exemple : referenceDoc = '#_Toc49435597';

  public nomCampagneIsValid = true; //permet de vérifier dans l'écran récap si le nom de la campagne a été corrigé.
  public descriptionCampagneIsValid = true;
  public refCampagneIsValid = true;

  public Campagne: Campagne = new Campagne();
  public CampagneExt: CampagneExt = new CampagneExt();
  public campagneBeforeChanges!: Campagne;
  public logo!: SafeUrl;
  public EmailNotification: string;

  public listChampsFusionSF = [];
  public interactionIdSF = null;

  // C'est pour garder les tokcens en memoire

  // ATA@09-03-23 - Correctif VLN07 : JWT stocké dans le localStorage
  public ADMIN_APP_JWT: string = null;
  public STANDALONE_APP_JWT: string = null;
  public ELOQUA_APP_JWT: string = null;
  public SALESFORCE_APP_JWT: string = null;
  public SF_FUEL_TOKEN: string = null;
  public SF_FUEL_API_REST_HOST: string = null;

  public tabWindowId: any;

  public stepper!: MatStepper;
  public completedStepsEvt: EventEmitter<number[]> = new EventEmitter<number[]>();

  public formEstimate!: FormGroup;

  public isLoaded: boolean = false;

  public sharedLists: Array<any>;
  public availableCamapgnes = new Array<Campagne>();
  public availableCampagnesLoading = false;
  public availableCampagnesError = false;

  public showSpinner: boolean = false;

  public standalone_username: string = null;
  public standalone_password: string = null;

  // public APP_JWT = null;

  // CONTEXT is either "STANDALONE", "ELOQUA" or "SALESFORCE"
  public CONTEXT: string = '';

  private changedCampagne$: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  public changedCampagneObs$: Observable<boolean>;
  private pendingCampagneExtDraft: Partial<CampagneExt> | null = null;


  constructor(
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
  ) {
    console.log('version', this.version);
    this.ensureCampaignStructures();
    this.changedCampagneObs$ = this.changedCampagne$.asObservable();
  }
  private ensureCampaignStructures(): void {
    if (!this.Campagne) {
      this.Campagne = new Campagne();
    }
    if (!this.CampagneExt) {
      this.CampagneExt = new CampagneExt();
    }
    if (!Array.isArray(this.CampagneExt.FichiersCreation)) {
      this.CampagneExt.FichiersCreation = [];
    }
    if (!Array.isArray(this.CampagneExt.ChampsFusion)) {
      this.CampagneExt.ChampsFusion = [];
    }
    if (!Array.isArray(this.CampagneExt.completedSteps)) {
      this.CampagneExt.completedSteps = [];
    }
    if (!this.CampagneExt.Adresse) {
      this.CampagneExt.Adresse = new AdresseRetour(this.Annonceur);
    }
    if (!this.CampagneExt.FichiersCreationsURL) {
      this.CampagneExt.FichiersCreationsURL = {};
    }
    if (!this.CampagneExt.FichiersCreationsType) {
      this.CampagneExt.FichiersCreationsType = {};
    }
    if (typeof this.CampagneExt.NbFichiersCreation !== 'number') {
      this.CampagneExt.NbFichiersCreation = 0;
    }
    if (typeof this.CampagneExt.NbFichiersPersonnalisation !== 'number') {
      this.CampagneExt.NbFichiersPersonnalisation = 0;
    }
    if (typeof this.CampagneExt.NbFichiersLogo !== 'number') {
      this.CampagneExt.NbFichiersLogo = 0;
    }
  }
  public initialiseAuthFromStorage(currentPath: string = window.location.pathname): void {
    const resolvedContext = this.resolveContextFromPath(currentPath);
    if (resolvedContext) {
      this.CONTEXT = resolvedContext;
    }
    this.ADMIN_APP_JWT = this.readStorageValue('ADMIN_APP_JWT');
    this.ELOQUA_APP_JWT = this.readStorageValue('ELOQUA_APP_JWT');
    this.STANDALONE_APP_JWT = this.readStorageValue('STANDALONE_APP_JWT');
    this.SALESFORCE_APP_JWT = this.readStorageValue('SALESFORCE_APP_JWT');
  }
  private resolveContextFromPath(path: string): string | null {
    if (!path) {
      return null;
    }
    if (path.startsWith('/administration')) {
      return 'ADMIN';
    }
    if (path.startsWith('/standalone') || path.startsWith('/campagne')) {
      return 'STANDALONE';
    }
    if (path.startsWith('/eloqua')) {
      return 'ELOQUA';
    }
    if (path.startsWith('/salesforce')) {
      return 'SALESFORCE';
    }
    return null;
  }
  private readStorageValue(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  }
  private writeStorageValue(key: string, value: string | null): void {
    try {
      if (value === null || typeof value === 'undefined') {
        localStorage.removeItem(key);
        return;
      }
      localStorage.setItem(key, value);
    } catch {
      // Keep the UI usable if browser storage is unavailable.
    }
  }
  private getJwtStorageKey(context: string = this.CONTEXT): string | null {
    return this.jwtStorageKeyByContext[context] || null;
  }
  private setJwtokenInMemory(context: string, jwtToken: string): void {
    switch (context) {
      case 'ADMIN':
        this.ADMIN_APP_JWT = jwtToken;
        break;
      case 'ELOQUA':
        this.ELOQUA_APP_JWT = jwtToken;
        break;
      case 'STANDALONE':
        this.STANDALONE_APP_JWT = jwtToken;
        break;
      case 'SALESFORCE':
        this.SALESFORCE_APP_JWT = jwtToken;
        break;
      default:
        break;
    }
  }
  private getCampaignPersistenceId(idCampagne: string | null | undefined): string {
    const normalizedId = typeof idCampagne === 'string' ? idCampagne.trim() : '';
    return normalizedId || 'CURRENT';
  }
  private getCampaignStepStorageKey(idCampagne: string | null | undefined): string {
    return `${this.CONTEXT || 'UNKNOWN'}_${this.campaignStepStoragePrefix}_${this.getCampaignPersistenceId(idCampagne)}`;
  }
  private getCampaignDraftStorageKey(idCampagne: string | null | undefined): string {
    return `${this.CONTEXT || 'UNKNOWN'}_${this.campaignDraftStoragePrefix}_${this.getCampaignPersistenceId(idCampagne)}`;
  }
  public isNewCampaignWizardRoute(): boolean {
    try {
      const navViewSegments = this.router.parseUrl(this.router.url).root.children['navview']?.segments || [];
      const navViewPath = navViewSegments[0]?.path;
      return navViewPath === 'nouvelle-campagne' ||
        (navViewPath === 'campagne-details' && navViewSegments.length === 1);
    } catch {
      return false;
    }
  }
  public saveCampaignDraft(
    campagne: Campagne = this.Campagne,
    campagneExt: CampagneExt = this.CampagneExt,
    persistenceId?: string | null,
  ): void {
    if (!campagne) {
      return;
    }
    try {
      // Files are uploaded through FichierCreaService and are reloaded from the
      // backend. Binary previews and file metadata must not become part of a
      // browser draft, otherwise a later campaign can inherit a stale PDF.
      const {
        FichiersCreation: _campagneFiles,
        FichiersCreationsURL: _campagneUrls,
        FichiersCreationsType: _campagneTypes,
        ...persistedCampagne
      } = campagne as any;
      const {
        FichiersCreation: _files,
        FichiersCreationsURL: _urls,
        FichiersCreationsType: _types,
        ...persistedCampagneExt
      } = campagneExt as any;
      const draftPersistenceId = typeof persistenceId !== 'undefined'
        ? persistenceId
        : this.isNewCampaignWizardRoute()
          ? null
          : campagne.IdCampagne;
      this.writeStorageValue(
        this.getCampaignDraftStorageKey(draftPersistenceId),
        JSON.stringify({
          campagne: persistedCampagne,
          campagneExt: persistedCampagneExt,
          savedAt: new Date().toISOString(),
        })
      );
    } catch {
      // Ignore serialization/storage errors to avoid breaking UI interactions.
    }
  }
  public clearCampaignDraft(idCampagne: string | null = null): void {
    this.writeStorageValue(this.getCampaignDraftStorageKey(idCampagne), null);
  }
  public consumeCampaignDraft(idCampagne: string | null = null): any | null {
    const key = this.getCampaignDraftStorageKey(idCampagne);
    const serializedDraft = this.readStorageValue(key);
    if (!serializedDraft) {
      return null;
    }
    try {
      const parsedDraft = JSON.parse(serializedDraft);
      return parsedDraft && typeof parsedDraft === 'object' ? parsedDraft : null;
    } catch {
      return null;
    }
  }
  public applyCampaignDraft(idCampagne: string | null = null): boolean {
    const draftPayload = this.consumeCampaignDraft(idCampagne);
    if (!draftPayload) {
      return false;
    }
    const draftCampagne =
      draftPayload?.campagne && typeof draftPayload.campagne === 'object'
        ? draftPayload.campagne
        : draftPayload;
    const draftCampagneExt =
      draftPayload?.campagneExt && typeof draftPayload.campagneExt === 'object'
        ? draftPayload.campagneExt
        : null;
    if (!draftCampagne || typeof draftCampagne !== 'object') {
      return false;
    }
    this.Campagne = Object.assign(
      this.Campagne || new Campagne(),
      draftCampagne,
      idCampagne ? { IdCampagne: idCampagne } : {},
      { isDirty: true }
    );
    this.pendingCampagneExtDraft = draftCampagneExt;
    // Only clear persisted draft after successfully applying it in memory
    try {
      this.writeStorageValue(this.getCampaignDraftStorageKey(idCampagne), null);
    } catch {}
    return true;
  }
  public applyPendingCampaignExtDraft(): boolean {
    if (!this.pendingCampagneExtDraft) {
      return false;
    }
    this.ensureCampaignStructures();
    this.CampagneExt = Object.assign(this.CampagneExt, this.pendingCampagneExtDraft);
    this.pendingCampagneExtDraft = null;
    this.ensureCampaignStructures();
    return true;
  }
  public saveCampaignStep(idCampagne: string | null = null, stepIndex: number): void {
    if (stepIndex < 0) {
      return;
    }
    this.writeStorageValue(
      this.getCampaignStepStorageKey(idCampagne),
      String(stepIndex)
    );
  }
  public getSavedCampaignStep(idCampagne: string | null = null): number | null {
    const savedIndex = this.readStorageValue(
      this.getCampaignStepStorageKey(idCampagne)
    );
    if (savedIndex === null) {
      return null;
    }
    const parsedIndex = Number(savedIndex);
    return Number.isInteger(parsedIndex) ? parsedIndex : null;
  }
  public clearSavedCampaignStep(idCampagne: string | null = null): void {
    this.writeStorageValue(this.getCampaignStepStorageKey(idCampagne), null);
  }

  /**
   * Starts a genuinely new wizard session. The root service is a singleton,
   * so resetting only the component would leave old campaign data in memory.
   */
  public resetForNewCampaign(): void {
    const previousCampaignId = this.Campagne?.IdCampagne || null;

    this.clearCampaignDraft(previousCampaignId);
    this.clearCampaignDraft(null);
    this.clearSavedCampaignStep(previousCampaignId);
    this.clearSavedCampaignStep(null);
    this.clearSavedCurrentCampaignNavigation();

    this.pendingCampagneExtDraft = null;
    this.Campagne = new Campagne(this.Annonceur);
    this.Campagne.IdProduit = '0';
    this.Campagne.IdAdresse = '0';
    this.Campagne.IdCampagneCopie = '0';
    this.CampagneExt = new CampagneExt();
    this.CampagneExt.Adresse = new AdresseRetour(this.Annonceur);
    this.CampagneExt.VitessesProduit = ['Classique', 'Rapide'];

    this.produits = [];
    this.availableCamapgnes = [];
    this.availableCampagnesLoading = false;
    this.availableCampagnesError = false;
    this.availableAdresses = [];
    this.availableChampsFusion = [];
    this.availableEloquaChampsFusion = [];
    this.listChampsFusionDisponible = [];
    this.sharedLists = [];
    this.stepIndex = 0;
    this.isLoaded = false;
    this.nomCampagneIsValid = true;
    this.descriptionCampagneIsValid = true;
    this.refCampagneIsValid = true;
    this.ensureCampaignStructures();
    this.checkStepCompletion();
  }
  private getNavViewStateStorageKey(context: string): string {
    return `${context || 'UNKNOWN'}_${this.navViewStateStoragePrefix}`;
  }
  private getCurrentCampaignNavigationStorageKey(context: string): string {
    return `${context || 'UNKNOWN'}_${this.currentCampaignNavigationStoragePrefix}`;
  }
  public saveNavViewState(commands: any[], context: string = this.CONTEXT): void {
    if (!commands?.length) {
      return;
    }
    this.writeStorageValue(
      this.getNavViewStateStorageKey(context),
      JSON.stringify(commands)
    );
    this.saveCurrentCampaignNavigation(commands, context);
  }
  public getSavedNavViewState(context: string = this.CONTEXT): any[] | null {
    const storedValue = this.readStorageValue(this.getNavViewStateStorageKey(context));
    if (!storedValue) {
      return null;
    }
    try {
      const commands = JSON.parse(storedValue);
      return Array.isArray(commands) ? commands : null;
    } catch {
      this.writeStorageValue(this.getNavViewStateStorageKey(context), null);
      return null;
    }
  }
  private saveCurrentCampaignNavigation(commands: any[], context: string): void {
    const view = typeof commands?.[0] === 'string' ? commands[0] : '';
    const campaignId = commands?.[1] == null ? '' : String(commands[1]).trim();
    if (
      !this.campaignNavigationViews.has(view) ||
      !campaignId ||
      campaignId === 'undefined' ||
      campaignId === 'null'
    ) {
      return;
    }
    this.writeStorageValue(
      this.getCurrentCampaignNavigationStorageKey(context),
      JSON.stringify([view, campaignId])
    );
  }
  public getSavedCurrentCampaignNavigation(context: string = this.CONTEXT): any[] | null {
    const storedValue = this.readStorageValue(
      this.getCurrentCampaignNavigationStorageKey(context)
    );
    if (!storedValue) {
      return null;
    }
    try {
      const commands = JSON.parse(storedValue);
      return Array.isArray(commands) ? commands : null;
    } catch {
      this.clearSavedCurrentCampaignNavigation(context);
      return null;
    }
  }
  public clearSavedCurrentCampaignNavigation(context: string = this.CONTEXT): void {
    this.writeStorageValue(this.getCurrentCampaignNavigationStorageKey(context), null);
  }
  public rememberCurrentCampaignNavigation(
    view: string,
    campaignId: string,
    context: string = this.CONTEXT
  ): void {
    this.saveCurrentCampaignNavigation([view, campaignId], context);
  }
  public campagneChanged() {
    this.changedCampagne$.next(true);
  }

  /**
   * permer d'afficher une alerte
   * @param message message à afficher
   */
  alert(message: string, errorMessage?: string) {
    this.dialog.open(DialogMessageComponent, {
      data: {
        message: message,
        errorMessage: errorMessage,
        titre: 'Cap Mailing Plateforme',
        BouttonConfirmation: false,
      },
    });
  }

  dialogAnnulation(data: any) {
    return this.dialog.open(DialogAnnulationCampagneComponent, {
      data: data,
    });
  }

  /**
   * 
   * @param data   {
    message: '';
    titre: 'Cap Mailing Plateforme';
    BouttonConfirmation: false;
    }
   */
  confirm(data: any) {
    return this.dialog.open(DialogMessageComponent, {
      data: data,
    });
  }

  openSnackBarInfo(message: string) {
    console.log('openSnackBarInfo : ' + message);
    this.alert(
      "Erreur technique.<br> Si le problème persiste, veuillez rouvrir l'application CapMailing Plateforme."
    );
    // this.alert("Erreur serveur. <br>" +
    // "Veuillez vérifier votre connexion internet. <br>" +
    // CTBEB-446 (CFZ @ 2020-10-21) : Remove sentence about fields.
    //"Veuillez vérifier les champs renseignés. <br>"+
    // "Si le problème persiste, veuillez rouvrir l'application Cap Mailing Plateforme");

    /** Pas daffichage de notif si y a une erreur dans l'api
     * */
    // this.snackBar.open(message, 'OK', {
    //       duration: 5000,
    //       horizontalPosition: 'center',
    //       verticalPosition: 'top',

    //     });
  }

  /**
   *
   * @param key : filtrer sur ce champ
   */
  distinct(array: any, key: any) {
    return [
      ...new Map(
        array.map((item: { [x: string]: any }) => [item[key], item])
      ).values(),
    ];
  }

  /**
   * 
   * @param key : filtrer sur ce champ
   
  distinct(array: { map: (arg0: (item: any) => any[]) => Iterable<readonly [unknown, unknown]>; }, key: string | number) {
    return [...new Map(array.map((item: { [x: string]: any; }) => [item[key], item])).values()];
  }*/

  didCampagneProductChange(campagne: any) {
    const fields: string[] = [
      'CodeSupport',
      'CodeTypologie',
      'CodeDimensionsSupport',
      'CodeGrammageSupport',
      'CodeFinitionSupport',
      'CodeEncreSupport',
      'CodeEnveloppe',
      'CodeDimensionsEnveloppe',
      'CodeGrammageEnveloppe',
      'CodeFinitionEnveloppe',
      'CodeEncreEnveloppe',
    ];
    let oldCampagne: any = this.campagneBeforeChanges || null;
    let newCampagne: any = campagne || null;

    console.log(oldCampagne, newCampagne);

    if (oldCampagne) {
      for (const field of fields) {
        if (oldCampagne[field] == 'null') oldCampagne[field] = null;
        if (oldCampagne[field] != newCampagne[field] && oldCampagne[field]) {
          console.log('Field ' + field + ' differ.');
          // this.alert("Vous avez opté pour un autre produit, merci de remplacer les fichiers à envoyer en production.");
          return true;
        }
      }
    }
    return false;
  }

  getLibelleProduit(
    codeName: string | number,
    codeValue: any,
    libelleName: string | number
  ) {
    let produit;
    if (this.produits !== undefined) {
      produit = this.produits.find(
        (x: { [x: string]: any }) => x[codeName] === codeValue
      )!;
      if (produit !== undefined && produit[libelleName])
        return produit[libelleName];
      else return null;
    } else return null;
  }

    getStatutMapping(): Promise<void> {
    // ATA@20230403 - Security enhancements
    // if (this.isTokenExpired(this.getJwtoken())) {
    //   this.refreshToken();
    // }
    if (Object.keys(this.mappingStatut).length > 0) {
      return Promise.resolve();
    }
    let statusUrl = environment.url_api + '/statutConfig/list';

    return new Promise<void>((resolve) => {
      this.http
        .get<any>(statusUrl, {
          params: this.objectParams,
          headers: new HttpHeaders({
            Authorization: `Bearer ${this.getJwtoken()}`,
          }),
        })
        // this.http.get<any>(statusUrl, { params: this.objectParams })
        .subscribe((response) => {
          if (Array.isArray(response?.statutConfig)) {
            this.mappingStatut = {};
            response.statutConfig.forEach(
              (statutConfig: {
                codeStatut: string;
                libelle: string;
                percentage: string;
              }) => {
                this.mappingStatut[statutConfig.codeStatut] =
                  statutConfig.libelle;
                this.mappingPercentage[statutConfig.codeStatut] =
                  statutConfig.percentage;
              }
            );
          }
          resolve();
        }, () => {
          // Status labels are optional for rendering the wizard. Do not leave
          // callers waiting forever when this reference endpoint is down.
          resolve();
        });
    });
  }

  isEloquaContext() {
    return this.CONTEXT === 'ELOQUA';
  }

  isStandaloneContext() {
    return this.CONTEXT === 'STANDALONE';
  }

  isSalesforceContext() {
    return this.CONTEXT === 'SALESFORCE';
  }

  public getResolvedAnnonceurId(): string | null {
    const candidates = [
      this.Annonceur?.IdAnnonceur,
      this.Campagne?.IdAnnonceur,
    ];
    try {
      candidates.push(this.getJWTAnnonceurId());
    } catch {
      // A malformed or expired token is handled by the authentication flow.
    }
    const resolvedId = candidates.find((value) => {
      const normalizedValue = value == null ? '' : String(value).trim();
      return normalizedValue !== '' && normalizedValue !== '0' && normalizedValue !== '-1';
    });
    return resolvedId == null ? null : String(resolvedId).trim();
  }

  getJWTAnnonceurId() {
    const token = this.getJwtoken();

    if (!token) return -1;
    const jsonToken = JSON.parse(atob(token.split('.')[1]));

    return jsonToken.idAnnonceur;
  }

  getJWTLoginName() {
    const token = this.getJwtoken();

    if (!token) return null;
    const jsonToken = JSON.parse(atob(token.split('.')[1]));

    return jsonToken.sub;
  }

  isAdminAnnonceur() {
    const token = this.getJwtoken();

    if (!token) return false;
    const jsonToken = JSON.parse(atob(token.split('.')[1]));

    return jsonToken.auth.indexOf('ADMIN_ANNONCEUR_STANDALONE') !== -1;
  }

  isAdminLaposte() {
    const token = this.getJwtoken();

    if (!token) return false;
    const jsonToken = JSON.parse(atob(token.split('.')[1]));

    return (
      jsonToken.auth.indexOf('ADMIN_LAPOSTE') !== -1 ||
      jsonToken.auth.indexOf('ROLE_ADMIN') !== -1
    );
  }

  _getJwtoken() {
    return this.readStorageValue(this.CONTEXT + '_APP_JWT');
    }

  // ATA@09-03-23 - Correctif VLN07 : JWT stocké dans le localStorage
  getJwtoken() {
    const storageKey = this.getJwtStorageKey();
    switch (this.CONTEXT) {
      case 'ADMIN':
        if (this.ADMIN_APP_JWT) return this.ADMIN_APP_JWT;
        break;
      case 'ELOQUA':
        if (this.ELOQUA_APP_JWT) return this.ELOQUA_APP_JWT;
        break;
      case 'STANDALONE':
        if (this.STANDALONE_APP_JWT) return this.STANDALONE_APP_JWT;
        break;
      case 'SALESFORCE':
        if (this.SALESFORCE_APP_JWT) return this.SALESFORCE_APP_JWT;
        break;
      default:
        break;
    }
    if (!storageKey) {
      return null;
    }
    const persistedToken = this.readStorageValue(storageKey);
    if (persistedToken) {
      this.setJwtokenInMemory(this.CONTEXT, persistedToken);
    }
    return persistedToken;
  }

  

  // ATA@09-03-23 - Correctif VLN07 : JWT stocké dans le localStorage
  setJwtoken(jwtToken: string) {
    const storageKey = this.getJwtStorageKey();
    if (!storageKey) {
      return;
    }
    this.setJwtokenInMemory(this.CONTEXT, jwtToken);
    this.writeStorageValue(storageKey, jwtToken);
  }


  // ATA@09-03-23 - Correctif VLN07 : JWT stocké dans le localStorage
  getinteractionIdSF() {
    // return this.cookieService.get('interactionIdSF');
    return this.interactionIdSF;
  }

  // ATA@09-03-23 - Correctif VLN07 : JWT stocké dans le localStorage
  setinteractionIdSF(_interactionIdSF: string) {
    this.interactionIdSF = _interactionIdSF;
    this.cookieService.set('interactionIdSF', _interactionIdSF, {
      sameSite: 'None',
      secure: true,
    });
  }

  // ATA@09-03-23 - Correctif VLN07 : JWT stocké dans le localStorage
  getSF_FUEL_TOKEN() {
    // return this.cookieService.get('SF_FUEL_TOKEN');
    return this.SF_FUEL_TOKEN;
  }

  // ATA@09-03-23 - Correctif VLN07 : JWT stocké dans le localStorage
  setSF_FUEL_TOKEN(token: string) {
    // this.cookieService.set('SF_FUEL_TOKEN', token,{sameSite: 'None',secure: true });     
    this.SF_FUEL_TOKEN = token;
  }

  // ATA@09-03-23 - Correctif VLN07 : JWT stocké dans le localStorage
  getSF_FUEL_API_REST_HOST() {
    // return this.cookieService.get('SF_FUEL_API_REST_HOST');
    return this.SF_FUEL_API_REST_HOST;
  }

  setSF_FUEL_API_REST_HOST(token: string) {
    // this.cookieService.set('SF_FUEL_API_REST_HOST',token,{sameSite: 'None',secure: true });
    this.SF_FUEL_API_REST_HOST = token;
  }

  // ATA@09-03-23 - Correctif VLN07 : JWT stocké dans le localStorage
  getSF_FUEL_API_REST_HOSTEN() {
    // return this.cookieService.get('SF_FUEL_API_REST_HOST');
    return this.SF_FUEL_API_REST_HOST;
  }

  setSF_FUEL_API_REST_HOSTEN(token: string) {
    // this.cookieService.set('SF_FUEL_API_REST_HOST', token,{sameSite: 'None',secure: true });
    this.SF_FUEL_API_REST_HOST = token;
  }

  // ATA@09-03-23 -Security enhancements
  isTokenExpired(token: string) {
    if (!token) {
      return true;
    }
    try {
      const expiry = JSON.parse(atob(token.split('.')[1])).exp;
      return expiry * 1000 <= Date.now();
    } catch {
      return true;
    }
  }

  _refreshSFToken() {
    let baseUrl: string = environment.url_api + '/salesforce';
    let url = baseUrl + '/checkToken';

    let authTokens = { fuel2token: this.getSF_FUEL_TOKEN() };
    let fuelapiRestHost = this.getSF_FUEL_API_REST_HOST();

    this.http
      .post<any>(
        url,
        { request: { tokens: authTokens, fuelapiRestHost: fuelapiRestHost } },
        {}
      )
      .subscribe(
        async (result) => {
          console.log('result is ', result);
          if (result) {
            console.log('id token ', result.id_token);
            this.setJwtoken(result.id_token);
          } else {
            this.router.navigate(['/erreur'], {
              queryParams: this.objectParams,
              queryParamsHandling: 'merge',
            });
          }
        },
        (error) => {
          console.debug('isAuth fail', error);
        }
      );
  }

  refreshSFToken(interactionIdSF: string) {
    let baseUrl: string = environment.url_api + '/salesforce';
    let url = baseUrl + '/refreshToken';

    return this.http.post<any>(
      url,
      { request: { interactionIdSF: interactionIdSF } },
      {}
    );
  }

  _refreshEloquaToken() {
    let eloquaParams = {
      ELOQUA_URI_PATH: 'eloqua/bootstrap',
      ELOQUA_HTTP_METHOD: 'GET',
    };

    let baseUrl: string = environment.url_gateway + '/eloqua';
    let url = baseUrl + '/refreshToken';

    this.http.post<any>(url, {}, { params: Object.assign(eloquaParams, this.objectParams) })
      .subscribe(async (result) => {
        console.log("result is ", result);
        if (result) {
          console.log('id token ', result.id_token);
          this.setJwtoken(result.id_token);
        } else {
          this.router.navigate(['/erreur'], {
            queryParams: this.objectParams, queryParamsHandling: "merge"
          });
        }
      },
        (error) => {
          console.debug("isAuth fail", error);
        }
      );
  }

  refreshEloquaToken(): Observable<any> {
    let eloquaParams = {
      ELOQUA_URI_PATH: 'eloqua/bootstrap',
      ELOQUA_HTTP_METHOD: 'GET',
    };

    let baseUrl: string = environment.url_gateway + '/eloqua';
    let url = baseUrl + '/refreshToken';

    return this.http.post<any>(url, {}, {
      params: Object.assign(eloquaParams, this.objectParams)
    });
  }

  refreshStandaloneToken() {
    let baseUrl: string = environment.url_api + '/standalone';
    let url = baseUrl + '/authenticate';
    this.http.post<any>(url, {
      "username": this.standalone_username,
      "password": this.standalone_password,
      "rememberMe": false
    })
      .subscribe(async (result) => {
        console.log("result is ", result);
        if (result) {
          console.log('id token ', result.id_token);
          this.setJwtoken(result.id_token);
        } else {
          this.router.navigate(['/erreur'], {
            queryParams: this.objectParams, queryParamsHandling: "merge"
          });
        }
      },
        (error) => {
          console.debug("isAuth fail", error);
        }
      );
  }

  refreshToken() {
    switch (this.CONTEXT) {
      case 'ADMIN':
        this.refreshStandaloneToken();
        break;
      case 'STANDALONE':
        this.refreshStandaloneToken();
        break;
      case 'ELOQUA':
        this.refreshEloquaToken();
        break;
      case 'SALESFORCE':
        this.refreshSFToken(this.getinteractionIdSF());
        break;
      default:
        break;
    }
  }

  isValidDate(date: string) {
    //console.log('isValidDate : ' + date);
    if (date == null) return false;
    let dateWrapper = new Date(date);
    return !isNaN(dateWrapper.getDate());
  }

  setOptionRetour() {
    this.Campagne.OptionRetour = '';
    if (
      !this.Annonceur.NumeroContratAlliage ||
      (this.Campagne.IdAdresse != '0' && this.Campagne.IdAdresse)
    ) {
      this.Campagne.OptionRetour = 'AdresseRetour';
    } else if (this.Campagne.Alliage) this.Campagne.OptionRetour = 'Alliage';
  }

  checkStepCompletion() {
    this.ensureCampaignStructures();
    console.log('checkStepCompletion');

    this.CampagneExt.completedSteps = [];
    const champsFusion = Array.isArray(this.CampagneExt.ChampsFusion)
      ? this.CampagneExt.ChampsFusion
      : [];

    // Step 1 - Identification
    if (this.Campagne.NomCampagne && this.Campagne.NomCampagne.length <= 100)
      this.CampagneExt.completedSteps.push(1);

    // Step 2 - Typologie
    if (
      !(
        this.Campagne.IdProduit === undefined ||
        this.Campagne.IdProduit == '' ||
        this.Campagne.IdProduit == '0'
      )
    ) {
      this.CampagneExt.completedSteps.push(2);
    }
    // Step 3 - Créations
    if (
      this.CampagneExt.NbFichiersPersonnalisation > 0 ||
      this.CampagneExt.NbFichiersCreation > 0
    )
      this.CampagneExt.completedSteps.push(3);

    // Step 4 - Personalisation
    if (this.hasSelectedPersonalisationFields()) {
      this.CampagneExt.completedSteps.push(4);
    }

    // Step 5 - Planification
    // contrôle de la fréquence d'envoi
      if (this.Campagne.FrequenceEnvoi == "Récurrente") {
        if (this.Campagne.DateDeDebut && this.Campagne.DateDeFin) {
          this.CampagneExt.completedSteps.push(5);
        }
      } else if (this.Campagne.FrequenceEnvoi == 'Une seule fois') {
        if (
          !(
            this.Campagne.DateRemiseImprimeur === undefined ||
            this.Campagne.DateRemiseImprimeur == 'null' ||
            this.Campagne.DateRemiseImprimeur == ''
          )
        ) {
          this.CampagneExt.completedSteps.push(5);
        }
    } 

    // Step 6 - Adresses
    if (this.isStandaloneContext() && this.Campagne.importOption === 'sftp') {
      // Option Alliage 
      if (this.Campagne.Alliage && this.logo) {
        this.CampagneExt.completedSteps.push(6);
      }
      //  Option Adresse de Retour 
      if (!this.Campagne.Alliage && !(!this.Campagne.IdAdresse || this.Campagne.IdAdresse == "0")) {
        this.CampagneExt.completedSteps.push(6);
      }
    }
    else if (champsFusion.filter(cf => cf.IsPaveAdresse == '1' || cf.IsPaveAdresse == 'true').length > 0) {      // Option Alliage 
      if (this.Campagne.Alliage && this.logo) {
        this.CampagneExt.completedSteps.push(6);
      }
      // Option Adresse de Retour 
      if (!this.Campagne.Alliage && !(!this.Campagne.IdAdresse || this.Campagne.IdAdresse == "0")) {
        this.CampagneExt.completedSteps.push(6);
      }
    }

    this.completedStepsEvt.emit(this.CampagneExt.completedSteps);
  }

  hasSelectedPersonalisationFields() {
    this.ensureCampaignStructures();
    return this.CampagneExt.ChampsFusion.filter(
      cf => cf.IsPaveAdresse == '0' || cf.IsPaveAdresse == 'false'
    ).length > 0;
  }

  getNbFichiersCreation() {
    this.ensureCampaignStructures();
    return this.CampagneExt.FichiersCreation.filter(
      (fichier) => fichier.FichierCreation === '1'
    ).length;
  }

  getNbFichiersPersonnalisation() {
    this.ensureCampaignStructures();
    return this.CampagneExt.FichiersCreation.filter(
      (fichier) => fichier.FichierCreation === '0'
    ).length;
  }

  getNbFichiersLogo() {
    this.ensureCampaignStructures();
    return this.CampagneExt.FichiersCreation.filter(
      (fichier) => fichier.FichierCreation === '2'
    ).length;
  }

  onComponentDestroy() {}

  getEstimationRequest(): EstimationRequest {
    let request: EstimationRequest = new EstimationRequest();
    if (this.CampagneExt.Produit) {
      request.custAccNumber = this.Annonceur.NumeroClient;
      request.contractNumber = this.Annonceur.NumeroContrat;
      request.quantity = this.Campagne.volume;

      request.criteria = new Criteria();
      request.criteria.item_type = this.CampagneExt.Produit
        .CodeTypologie as string;
      request.criteria.folding = this.CampagneExt.Produit.CodeSupport as string;
      request.criteria.printFormatValue = this.CampagneExt.Produit
        .CodeDimensionsSupport as string;
      request.criteria.paperGrammageCode = this.CampagneExt.Produit
        .CodeGrammageSupport as string;
      request.criteria.glossLevel = this.CampagneExt.Produit
        .CodeFinitionSupport as string;
      request.criteria.printingInkType = this.CampagneExt.Produit
        .CodeEncreSupport as string;
      request.criteria.windowEnvelope = this.CampagneExt.Produit
        .CodeEnveloppe as string;
      request.criteria.envelopType = this.CampagneExt.Produit
        .CodeDimensionsEnveloppe as string;
      request.criteria.envelope_paperGrammage = this.CampagneExt.Produit
        .CodeGrammageEnveloppe as string;
      request.criteria.envelope_glossLevel = this.CampagneExt.Produit
        .CodeFinitionEnveloppe as string;
      request.criteria.envelope_printingInkType = this.CampagneExt.Produit
        .CodeEncreEnveloppe as string;
      request.criteria.deliveryPriority = this.getLibelleProduit(
        'Vitesse',
        this.Campagne.CodeVitesse,
        'CodeVitesse'
      );
      request.criteria.campaignProductionMode = this.CampagneExt.Produit
        .CodeModeDeProduction as string;

      return request;
    } else return null;
  }

  getVitessesProduit(): Array<string> {
    let listeProduits: any;
    let VitesssProduit = new Array<string>();
    if (this.Campagne.CodeEnveloppe) {
      listeProduits = this.produits.filter(
        (element: Produit) =>
          element.CodeTypologie == this.Campagne.CodeTypologie &&
          element.CodeSupport == this.Campagne.CodeSupport &&
          element.CodeDimensionsSupport ==
            this.Campagne.CodeDimensionsSupport &&
          element.CodeGrammageSupport == this.Campagne.CodeGrammageSupport &&
          element.CodeFinitionSupport == this.Campagne.CodeFinitionSupport &&
          element.CodeEncreSupport == this.Campagne.CodeEncreSupport &&
          element.CodeEnveloppe == this.Campagne.CodeEnveloppe &&
          element.CodeDimensionsEnveloppe ==
            this.Campagne.CodeDimensionsEnveloppe &&
          element.CodeGrammageEnveloppe ==
            this.Campagne.CodeGrammageEnveloppe &&
          element.CodeFinitionEnveloppe ==
            this.Campagne.CodeFinitionEnveloppe &&
          element.CodeEncreEnveloppe == this.Campagne.CodeEncreEnveloppe
      );
    } else {
      listeProduits = this.produits.filter(
        (element: Produit) =>
          element.CodeTypologie == this.Campagne.CodeTypologie &&
          element.CodeSupport == this.Campagne.CodeSupport &&
          element.CodeDimensionsSupport ==
            this.Campagne.CodeDimensionsSupport &&
          element.CodeGrammageSupport == this.Campagne.CodeGrammageSupport &&
          element.CodeFinitionSupport == this.Campagne.CodeFinitionSupport &&
          element.CodeEncreSupport == this.Campagne.CodeEncreSupport
      );
    }

    listeProduits.forEach((p: any) => {
      VitesssProduit.push(p.Vitesse);
    });
    return VitesssProduit;
  }

  // Vérifie si le prodit de la campagne a dupliquer existe dans le nouveau catalogue
  checkCampagneProduit(campagne: Campagne): boolean {
    let listeProduits: any;

    if (campagne.CodeEnveloppe) {
      listeProduits = this.produits.filter(
        (element: Produit) =>
          element.CodeTypologie == campagne.CodeTypologie &&
          element.CodeSupport == campagne.CodeSupport &&
          element.CodeDimensionsSupport == campagne.CodeDimensionsSupport &&
          element.CodeGrammageSupport == campagne.CodeGrammageSupport &&
          element.CodeFinitionSupport == campagne.CodeFinitionSupport &&
          element.CodeEncreSupport == campagne.CodeEncreSupport &&
          element.CodeEnveloppe == campagne.CodeEnveloppe &&
          element.CodeDimensionsEnveloppe == campagne.CodeDimensionsEnveloppe &&
          element.CodeGrammageEnveloppe == campagne.CodeGrammageEnveloppe &&
          element.CodeFinitionEnveloppe == campagne.CodeFinitionEnveloppe &&
          element.CodeEncreEnveloppe == campagne.CodeEncreEnveloppe
      );
    } else {
      listeProduits = this.produits.filter(
        (element: Produit) =>
          element.CodeTypologie == campagne.CodeTypologie &&
          element.CodeSupport == campagne.CodeSupport &&
          element.CodeDimensionsSupport == campagne.CodeDimensionsSupport &&
          element.CodeGrammageSupport == campagne.CodeGrammageSupport &&
          element.CodeFinitionSupport == campagne.CodeFinitionSupport &&
          element.CodeEncreSupport == campagne.CodeEncreSupport
      );
    }
    if (listeProduits.length >= 1) return true;

    return false;
  }

  // Récupérer le produit du nouveau catalogue
  getCampagneProduit(campagne: Campagne): Produit {
    let listeProduits: Array<Produit>;

    if (campagne.CodeEnveloppe) {
      listeProduits = this.produits.filter(
        (element: Produit) =>
          element.CodeTypologie == campagne.CodeTypologie &&
          element.CodeSupport == campagne.CodeSupport &&
          element.CodeDimensionsSupport == campagne.CodeDimensionsSupport &&
          element.CodeGrammageSupport == campagne.CodeGrammageSupport &&
          element.CodeFinitionSupport == campagne.CodeFinitionSupport &&
          element.CodeEncreSupport == campagne.CodeEncreSupport &&
          element.CodeEnveloppe == campagne.CodeEnveloppe &&
          element.CodeDimensionsEnveloppe == campagne.CodeDimensionsEnveloppe &&
          element.CodeGrammageEnveloppe == campagne.CodeGrammageEnveloppe &&
          element.CodeFinitionEnveloppe == campagne.CodeFinitionEnveloppe &&
          element.CodeEncreEnveloppe == campagne.CodeEncreEnveloppe
      );
    } else {
      listeProduits = this.produits.filter(
        (element: Produit) =>
          element.CodeTypologie == campagne.CodeTypologie &&
          element.CodeSupport == campagne.CodeSupport &&
          element.CodeDimensionsSupport == campagne.CodeDimensionsSupport &&
          element.CodeGrammageSupport == campagne.CodeGrammageSupport &&
          element.CodeFinitionSupport == campagne.CodeFinitionSupport &&
          element.CodeEncreSupport == campagne.CodeEncreSupport
      );
    }
    if (listeProduits.length >= 1) return listeProduits[0];

    return <Produit>{};
  }

  isEmpty(obj: Record<string, any>): boolean {
    return Object.keys(obj).length === 0;
  }

  saveFusionFields() {
    // Fusion field save
    let url!: string;
    switch (this.CONTEXT) {
      case 'ELOQUA': {
        url = environment.url_api + '/champ-fusion';
        break;
      }
      case 'SALESFORCE': {
        url = environment.url_api + '/salesforce/champ-fusion';
        break;
      }
      case 'STANDALONE': {
        url = environment.url_api + '/standalone/champ-fusion';
        break;
      }
    }

    return this.http.post<any>(
      url + "/upsert",
      {
        request: {
          IdCampagne: this.Campagne.IdCampagne,
          ChampsFusion: this.CampagneExt.ChampsFusion,
        },
      },
      {
        params: this.objectParams,
        headers: new HttpHeaders({
          Authorization: `Bearer ${this.getJwtoken()}`,
        }),
      }
    )
  }

  saveCampaign(campagne: Campagne) {
    if (!campagne?.IdCampagne) {
      return throwError(() => new Error('Impossible d\'enregistrer une campagne sans identifiant.'));
    }

    // Save campaign
    var RequestCampagne = Object.assign({}, campagne);
    delete RequestCampagne.FichiersCreation;
    delete RequestCampagne.ChampsFusion;
    delete RequestCampagne.Produit;
    delete RequestCampagne.Adresse;

    if (!this.objectParams?.['AssetId'])
      this.objectParams = Object.assign({}, this.objectParams, {
        AssetId: '0000',
      });

    let url: string = environment.url_api;
    switch (this.CONTEXT) {
      case 'ELOQUA': {
        url += '/campagne/' + RequestCampagne.IdCampagne;
        break;
      }
      case 'STANDALONE': {
        url += '/standalone/campagne/' + RequestCampagne.IdCampagne;
        break;
      }
      case 'SALESFORCE': {
        if (this.getinteractionIdSF())
          this.objectParams = Object.assign({}, this.objectParams, {
            InteractionId: this.getinteractionIdSF(),
          });

        url += '/salesforce/campagne/' + RequestCampagne.IdCampagne;
        break;
      }
    }

    // TODO: To be deleted
    // Hotfix for Evol Env
    RequestCampagne.creationType = 'upload';

    return this.http.put<Campagne[]>(
      url,
      { request: RequestCampagne },
      {
        params: this.objectParams,
        headers: new HttpHeaders({
          Authorization: `Bearer ${this.getJwtoken()}`,
        }),
      }
    );
  }

  saveAll(campagne: Campagne, saveFusion: Boolean) {
    const isNewCampaign = !campagne?.IdCampagne;
    return this.ensurePersistedCampaign(campagne).pipe(
      switchMap((persistedCampagne) => {
        if (!saveFusion) {
          return this.saveCampaign(persistedCampagne);
        }

        // The first persistence creates an empty campaign server-side. Save
        // the draft itself before saving its fusion fields.
        if (isNewCampaign) {
          return this.saveCampaign(persistedCampagne).pipe(
            switchMap(() => this.saveFusionFields())
          );
        }

        return this.saveFusionFields();
      })
    );
  }

  /**
   * The standalone wizard starts with a local draft. Persist the empty target
   * campaign on the first save and keep the user's draft fields intact.
   */
  private ensurePersistedCampaign(campagne: Campagne): Observable<Campagne> {
    if (campagne?.IdCampagne) {
      return of(campagne);
    }

    if (!this.isStandaloneContext()) {
      return throwError(() => new Error('Impossible de créer la campagne : identifiant absent.'));
    }

    const url = environment.url_api + '/standalone/campagne/';
    return this.http.get<any>(url, {
      params: this.objectParams,
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.getJwtoken()}`,
      }),
    }).pipe(
      switchMap((response) => {
        const createdCampaign = response?.campagne;
        if (!createdCampaign?.IdCampagne) {
          return throwError(() => new Error('La création de la campagne n\'a retourné aucun identifiant.'));
        }

        this.Campagne = {
          ...createdCampaign,
          ...campagne,
          IdCampagne: createdCampaign.IdCampagne,
        };
        return of(this.Campagne);
      })
    );
  }

  public initialise() {
    this.Campagne = new Campagne();
    if (typeof this.Campagne.EmailNotification == 'undefined') {
      this.Campagne.EmailNotification = '';
    }

    this.CampagneExt = new CampagneExt();
    this.CampagneExt.Produit = {};
    this.CampagneExt.VitessesProduit = new Array<string>();
    this.CampagneExt.Adresse = new AdresseRetour(this.Annonceur);
    this.CampagneExt.FichiersCreation = [];
    this.CampagneExt.ChampsFusion = [];
    this.CampagneExt.FichiersCreationsURL = {};
    this.CampagneExt.FichiersCreationsType = {};
    this.CampagneExt.NbFichiersCreation = 0;
    this.CampagneExt.NbFichiersPersonnalisation = 0;
    this.CampagneExt.NbFichiersLogo = 0;

    this.CampagneExt.VitessesProduit = ['Classique', 'Rapide'];

    this.Campagne.volume = '';
    this.Campagne.unitAmountWithoutTax = '';
    this.Campagne.amountWithoutTax = '';

    this.Campagne.showInfo = false;
    this.Campagne.showRefresh = false;
    this.Campagne.showunitAmountWithoutTax = false;
    this.Campagne.showamountWithoutTax = false;
    this.Campagne.OptionRetour = '';
    this.checkStepCompletion();
  }
}
